import React from 'react'
import { ListItem, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  headerStyle: {
    paddingLeft: '1.5rem',
    marginBottom: 0,
    fontSize: 'inherit',
  },
  listStyle: {
    paddingTop: '0px !important',
  },
}))

const EmptySubscribersList = ({ message }) => {
  const classes = useStyles()
  return (
    <ListItem className={classes.listStyle}>
      <ListItemText primary={message} />
    </ListItem>
  )
}
export default EmptySubscribersList
